export var FAMILY_DETAILS = "FAMILY_DETAILS";
export var ERROR_MSG = "ERROR_MSG";
export var SELECTED_MEMBER = "SELECTED_MEMBER";
export var STOP_FAM_API_CALL = "STOP_FAM_API_CALL";
export var CONSOLIDATED_DETAILS = "CONSOLIDATED_DETAILS";
export var SEARCH = "SEARCH";
